export const order_Type = { PurchaseOrder: 1, SaleOrder: 2, InvoiceToGRN: 3 }